import { render, staticRenderFns } from "./CommissionsAndTaxes.vue?vue&type=template&id=02265eb8&scoped=true&"
import script from "./CommissionsAndTaxes.vue?vue&type=script&lang=js&"
export * from "./CommissionsAndTaxes.vue?vue&type=script&lang=js&"
import style0 from "./CommissionsAndTaxes.vue?vue&type=style&index=0&id=02265eb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02265eb8",
  null
  
)

export default component.exports